import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCode } from '@fortawesome/free-solid-svg-icons'
import { ModalConfirmV2, ModalSizeVariants } from '@labrav/react-components'
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter'
import { solarizedLight } from 'react-syntax-highlighter/dist/esm/styles/hljs'
import { updateAppAlert } from '@labrav/common'
import { useDispatch } from '../../../../store'
import { getEmbedCodeSnippet } from '../../helpers'
import { EMBED_COPY_FAILURE, EMBED_COPY_SUCCESS } from '../../constants'

interface EmbedCodeModalProps {
  integrationId: string
  partnerId: string
  open: boolean
  onClose: () => void
}

export const EmbedCodeModal: React.FC<EmbedCodeModalProps> = ({
  integrationId,
  partnerId,
  open,
  onClose,
}) => {
  const dispatch = useDispatch()
  const codeString = getEmbedCodeSnippet(integrationId, partnerId)
  const handleCopyModal = () => {
    navigator.clipboard.writeText(codeString).then(
      () => {
        dispatch(
          updateAppAlert({
            message: EMBED_COPY_SUCCESS,
            messageType: 'SUCCESS',
            autoClose: true,
          })
        )
        onClose()
      },
      () => {
        dispatch(
          updateAppAlert({
            message: EMBED_COPY_FAILURE,
            messageType: 'ERROR',
            autoClose: true,
          })
        )
      }
    )
  }

  return (
    <ModalConfirmV2
      title="Copy snippet to embed code"
      content={
        <SyntaxHighlighter
          language="html"
          style={solarizedLight}
          customStyle={{
            padding: '24px',
            borderRadius: '8px',
            fontSize: '14px',
            lineHeight: '1.5',
            backgroundColor: '#F6F7F9',
          }}
        >
          {codeString}
        </SyntaxHighlighter>
      }
      open={open}
      titleAcceptButton="Copy"
      onAccept={handleCopyModal}
      onDecline={onClose}
      variant={ModalSizeVariants.large}
      icon={
        <FontAwesomeIcon
          icon={faCode}
          style={{ width: '20px', height: '16px' }}
        />
      }
      hideCancelIcon={false}
      hideCancelButton={false}
    />
  )
}
